import script from "./CreateNewForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewForm.vue?vue&type=style&index=0&id=b3d454f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d454f6"]])

export default __exports__